import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ImageWidget: WidgetRegistryEntry = {
  name: "Image",
  component: () => import("./image-widget.component").then((m) => m.ImageWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.ImageWidgetConfiguration)
};
